import {Space, Image, Typography} from "antd";
import Logo from "./Graphics/Logo";
import {DoubleLine} from "./Labels";
import React from "react";
import {formatCompanyLogoUrl} from "../api/companyApi";
import {portfolioTypeString} from "../utils/strings";

const PortfolioChip = ({portfolioId, portfolioName, portfolioType, fontColor='#000', noGap=false,
                        imgSize=32, titleSize=14, textSize=11,
                        titleSuffix='', width=300, maxLength=30
                    })=>{
    const companyId = localStorage.getItem('cid') || 'finiat';
    const logoUrl = formatCompanyLogoUrl(companyId);

    return (
        <Space style={{width}}>
            <Image src={logoUrl} height={imgSize} width={'100%'} />
            <DoubleLine title={portfolioName}
                        text={portfolioTypeString(portfolioType)}
                        maxLength={maxLength}
                        titleSize={titleSize}
                        textSize={textSize}
                        textWeight={'600'}
                        fontColor={fontColor}
                        noGap={noGap}

            />
        </Space>
    )
}

export default PortfolioChip;